var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-item filter-item--dropdown" },
    [
      _c("h2", {
        staticClass: "filter-item__heading",
        domProps: { textContent: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c("search-selector", {
        attrs: {
          search: _vm.search,
          options: _vm.options,
          "icon-type": _vm.filterName
        },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0498e4e", { render: render, staticRenderFns: staticRenderFns })
  }
}